import { render, staticRenderFns } from "./PageListSmall.vue?vue&type=template&id=33f16c7a"
import script from "./PageListSmall.vue?vue&type=script&lang=js"
export * from "./PageListSmall.vue?vue&type=script&lang=js"
import style0 from "./PageListSmall.vue?vue&type=style&index=0&id=33f16c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports